(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'footerContacts', {
            bindings: {
                contactsModel:     '<'
            },
            templateUrl:    'app/views/partials/layout/footer-contacts.html',
            controller:     FooterContactsController,
            controllerAs:   'vm'
        });


        /**
         * @param {ng.IScope} $scope
         * @param {ContentSwitchingService} ContentSwitchingService
         * @param {Object} TEXTS
         */
        function FooterContactsController(
            $scope,
            ContentSwitchingService,
            TEXTS
        ){
            // Helper members.

            /** @type {angular.IController} */
            var vm = this;


            /** Wire to the Scope. */

            $scope._ = TEXTS;
             

            /** Defaults. */

            //vm.contacts   = undefined;
            //vm.heading    = undefined;
            //vm.isInternational  = undefined;


            /** Uni-directional watchers */

            vm.$onChanges = function( changesObject ) {
                if ( changesObject.contactsModel && changesObject.contactsModel.currentValue ) {
                    initContacts();
                    vm.$onChanges = function(){}; // Deregister event handler
                }
            };

            function initContacts() {
                vm.isInternational = ContentSwitchingService.isInternational();

                vm.contacts = vm.isInternational ? vm.contactsModel.international : vm.contactsModel;

                vm.heading = vm.contacts.heading;
            }
        }

        FooterContactsController.$inject = [ '$scope', 'ContentSwitchingService', 'TEXTS' ];
})();
